import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import type { ILink } from '../_interfaces/link.interface';

@Injectable({
  providedIn: 'root'
})
export class LinkService {
  private subject = new Subject<any>();

  sendClickLinkEvent(link: ILink) {
    this.subject.next(link);
  }

  onClickLink(): Observable<any> {
    return this.subject.asObservable();
  }
}
